"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _text = require("@mmc/text");
var _commonI18n = require("@mmc/common-i18n");
var _reactRedux = require("react-redux");
var types = _interopRequireWildcard(require("./vehicle-selector.prop-types"));
var _vehicleCard = _interopRequireDefault(require("./vehicle-card.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VehicleCard = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(VehicleCard, _React$PureComponent);
  function VehicleCard(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = VehicleCard.prototype;
  _proto.handleClick = function handleClick(e) {
    var vehicle = this.props.vehicle;
    if (!vehicle.isActive) e.preventDefault();

    // prevent routing if target is disclaimer related element
    var isSVG = ['svg', 'path'].includes(e.target.tagName);
    if (isSVG) e.preventDefault();
    var targetClassses = [].concat(e.target.classList);
    var isVehicleCard = targetClassses.some(function (className) {
      return className.value.includes('vehicle-card');
    });
    var isDisclaimerButton = targetClassses.some(function (className) {
      return className.value.includes('disclaimer-box__button');
    });
    var isPriceSpan = ['SPAN', 'SUP'].includes(e.target.tagName) ? [].concat(e.target.parentElement.classList).some(function (className) {
      return className.value.includes('vehicle-card');
    }) : false;
    if (isDisclaimerButton || !isVehicleCard && !isPriceSpan) {
      e.preventDefault();
    }
  };
  _proto.render = function render() {
    var _clsx;
    var _this$props = this.props,
      className = _this$props.className,
      _this$props$vehicle = _this$props.vehicle,
      isActive = _this$props$vehicle.isActive,
      imagePath = _this$props$vehicle.imagePath,
      imageAltText = _this$props$vehicle.imageAltText,
      vehicleName = _this$props$vehicle.vehicleName,
      _this$props$vehicle$p = _this$props$vehicle.price,
      zeroMessage = _this$props$vehicle$p.zeroMessage,
      value = _this$props$vehicle$p.value,
      displayValue = _this$props$vehicle$p.displayValue,
      msrpDisclaimer = _this$props.msrpDisclaimer,
      ngcLabel = _this$props.ngcLabel,
      isNgc = _this$props.isNgc,
      theme = _this$props.theme,
      to = _this$props.to,
      addPriceDisclaimer = _this$props.addPriceDisclaimer,
      priceDisclaimerId = _this$props.priceDisclaimerId,
      disclaimerData = _this$props.disclaimerData,
      _this$props$config = _this$props.config,
      currencyFormat = _this$props$config.currencyFormat,
      localeCode = _this$props$config.localeCode;
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: to,
      className: (0, _clsx2["default"])(_vehicleCard["default"].vehicleCard, className, (_clsx = {}, _clsx[_vehicleCard["default"].disabled] = !isActive, _clsx)),
      onClick: this.handleClick
    }, isNgc && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.mmcBold + " " + _vehicleCard["default"].ngcLabel
    }, ngcLabel), /*#__PURE__*/_react["default"].createElement("div", {
      className: _vehicleCard["default"].imageContainer
    }, imagePath && /*#__PURE__*/_react["default"].createElement("img", {
      className: _vehicleCard["default"].image,
      src: imagePath,
      alt: imageAltText
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _vehicleCard["default"].textContainer
    }, isNgc && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.mmcBold + " " + _vehicleCard["default"].ngcLabelMobile
    }, ngcLabel), /*#__PURE__*/_react["default"].createElement("p", {
      className: _vehicleCard["default"].name
    }, vehicleName), (value > 0 || zeroMessage) && /*#__PURE__*/_react["default"].createElement("p", {
      className: _vehicleCard["default"].price
    }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      className: "vehicle-card-disclaimer-price",
      format: "price",
      options: {
        value: value,
        currency: currencyFormat,
        locale: localeCode,
        displayValue: addPriceDisclaimer ? '' : displayValue,
        zeroMessage: zeroMessage
      }
    }), value > 0 && msrpDisclaimer && /*#__PURE__*/_react["default"].createElement("sup", null, msrpDisclaimer), addPriceDisclaimer && priceDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      tag: "span",
      text: "#" + priceDisclaimerId + "#",
      disclaimerData: disclaimerData,
      className: _vehicleCard["default"].msrpDisclaimer
    }))));
  };
  return VehicleCard;
}(_react["default"].PureComponent);
VehicleCard.displayName = 'VehicleCard';
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(VehicleCard);
exports["default"] = _default;